import { UserState } from '../../../../utils/apollo/graphqlSchema';

export const userStatesLabelLookup: Record<UserState, string> = {
  [UserState.Active]: 'Active',
  [UserState.Pending]: 'Pending',
  [UserState.Deleted]: 'Disabled',
};
